import { Skeleton } from 'ui'

export const SkeletonQrComposition = () => {
  return (
    <div className='w-full flex items-center justify-center flex-col text-center space-y-8'>
      <div>
        <p className='text-sm font-medium text-start'>
          Escanea el código QR con tu celular para firmar. Manténlo abierto hasta que hayas firmado.
        </p>
      </div>
      <div>
        <Skeleton className='h-[200px] w-[200px]' />
      </div>
      <p className='text-[9.5px] text-muted-foreground max-w-lg w-full text-start'>
        Al avanzar con tu firma electrónica, reconoces y consientes que se utilizará para firmar el documento
        indicado y posee la misma validez legal que una firma a mano. Al concluir el proceso de firma
        electrónica, confirmas tu entendimiento y aceptación de estas condiciones. Consulta la {' '}
        <a href={`${process.env.NEXT_PUBLIC_WEB_APP_BASE_URL}/legal/consent`} target='_blank' className='!pointer-events-auto underline'>divulgación de firma electrónica</a> completa.
      </p>
    </div>
  )
}
